<template>
    <v-alert
        text border='left'
        prominent color='info'
        class='mx-auto mb-3'
    >
        <v-card-text class='px-0 py-0'>
            <div class="mb-2">
                <v-icon color='info' class='ml-1'>mdi-alert-circle-outline</v-icon>
                <span class='font-weight-bold text--primary'>نکات مهم</span>
            </div>
            <div class='px-2 text--primary'>
                <slot/>
            </div>
        </v-card-text>

        <v-card-actions v-if="showActions" :class='$vuetify.breakpoint.smAndDown ? "flex-column" : ""'>
            <slot name='action'/>
        </v-card-actions>
    </v-alert>
</template>

<script>
export default {
    name: 'InfoAlert',
    computed: {
        showActions() {
            return !!this.$slots.action;
        }
    }
};
</script>

<style scoped>

</style>